class Header {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // ------------------------------
    // ヘッダー MVを超えたら帯を敷く
    // ------------------------------

    let options = {
      threshold: [0]
    }
    
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if(entry.intersectionRatio > 0) {
          $('html').removeClass('is-mv-header');
        } else {
          $('html').addClass('is-mv-header');
        }
      });
    }, options);

    observerEnter.observe($('.js-mv-trigger')[0]);
  }
}